import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

interface ProductConfig {
  transaction_category_id: string;
}

export default function logTilePress(
  productConfig: ProductConfig,
  source: string,
  validatedReferralCode: string | null,
  product: any,
): void {
  const event = AMPLITUDE_CONSTANTS.BillPayment.userClickedProduct;
  const { name, attributes } = event;
  AmplitudeHelper.logEvent(name, {
    [attributes.transaction_category_id]: productConfig.transaction_category_id,
    [attributes.source]: source,
    [attributes.referral_code]: validatedReferralCode || '',
    [attributes.is_favourite]: product?.isFavourites,
    [attributes.is_default_favourite]: product?.isDefaultFavorites,
  });
}
